import React, { useEffect, useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import DataTable from '../components/DataTable';

export default function SicilListesi() {
  const navigate = useNavigate();
  const [kayitlar, setKayitlar] = useState([]);
  const [q, setQ] = useState('');
  const [sicilTipi, setSicilTipi] = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const yukle = useCallback(async () => {
    setYukleniyor(true);
    try {
      const params = new URLSearchParams();
      if (q) params.append('q', q);
      if (sicilTipi) params.append('sicil_tipi', sicilTipi);
      const r = await api.get(`/sicil?${params}`);
      setKayitlar(r.data);
    } finally { setYukleniyor(false); }
  }, [q, sicilTipi]);

  useEffect(() => { yukle(); }, [yukle]);

  const fmt = d => d ? new Date(d).toLocaleDateString('tr-TR') : '';

  const columns = [
    {
      key: '_no', label: '#', width: '50px', sortable: false, filterable: false,
      render: (_, __, idx) => <span style={{ color: '#999', fontSize: '12px' }}>{idx + 1}</span>,
      exportValue: (r, i) => i + 1,
    },
    {
      key: 'unvani', label: 'Ad / Ünvan',
      render: (v, r) => (
        <div>
          <div style={{ fontWeight: '600' }}>{r.unvani || `${r.adi || ''} ${r.soyadi || ''}`}</div>
          {r.unvani && r.adi && <div style={{ fontSize: '11px', color: '#888' }}>{r.adi} {r.soyadi}</div>}
        </div>
      ),
      exportValue: r => r.unvani || `${r.adi || ''} ${r.soyadi || ''}`.trim(),
    },
    { key: 'adi', label: 'Adı', hidden: true, render: v => v || '—', exportValue: r => r.adi },
    { key: 'soyadi', label: 'Soyadı', hidden: true, render: v => v || '—', exportValue: r => r.soyadi },
    {
      key: 'tcno', label: 'TC Kimlik No', width: '130px',
      render: (v, r) => <span style={{ fontSize: '12px' }}>{v || r.vn || '—'}</span>,
      exportValue: r => r.tcno || r.vn,
    },
    { key: 'vn', label: 'Vergi No', width: '120px', hidden: true, render: v => v || '—', exportValue: r => r.vn },
    { key: 'vd', label: 'Vergi Dairesi', hidden: true, render: v => v || '—', exportValue: r => r.vd },
    {
      key: 'sicil_tipi', label: 'Sicil Tipi', width: '110px',
      render: v => {
        const map = { GERCEK: ['Gerçek Kişi', '#e8f5e9', '#1b5e20'], TUZEL: ['Tüzel Kişi', '#e3f2fd', '#1565c0'], KAMU: ['Kamu Kurumu', '#fff3e0', '#e65100'] };
        const [lbl, bg, color] = map[v] || [v, '#f5f5f5', '#555'];
        return <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', background: bg, color }}>{lbl}</span>;
      },
      exportValue: r => ({ GERCEK: 'Gerçek Kişi', TUZEL: 'Tüzel Kişi', KAMU: 'Kamu Kurumu' }[r.sicil_tipi] || r.sicil_tipi),
    },
    {
      key: 'cinsiyet', label: 'Cinsiyet', width: '90px', hidden: true,
      render: v => v ? (v === 'ERKEK' ? 'Erkek' : 'Kadın') : '—',
      exportValue: r => r.cinsiyet === 'ERKEK' ? 'Erkek' : r.cinsiyet === 'KADIN' ? 'Kadın' : '',
    },
    { key: 'milliyet_adi', label: 'Milliyet', hidden: true, render: v => v || '—', exportValue: r => r.milliyet_adi },
    { key: 'babadi', label: 'Baba Adı', hidden: true, render: v => v || '—', exportValue: r => r.babadi },
    { key: 'anadi', label: 'Ana Adı', hidden: true, render: v => v || '—', exportValue: r => r.anadi },
    { key: 'dogum_yeri', label: 'Doğum Yeri', hidden: true, render: v => v || '—', exportValue: r => r.dogum_yeri },
    { key: 'dogum_tarihi', label: 'Doğum Tarihi', width: '110px', hidden: true, render: v => fmt(v), exportValue: r => fmt(r.dogum_tarihi) },
    { key: 'sirket_tipi_adi', label: 'Şirket Tipi', hidden: true, render: v => v || '—', exportValue: r => r.sirket_tipi_adi },
    { key: 'tc_sicil_no', label: 'TC Sicil No', hidden: true, render: v => v || '—', exportValue: r => r.tc_sicil_no },
    {
      key: 'telefon', label: 'Sabit Telefon', width: '130px', hidden: true,
      render: v => <span style={{ fontSize: '12px' }}>{v || '—'}</span>,
      exportValue: r => r.telefon,
    },
    {
      key: 'cep_telefonu', label: 'Cep Telefonu', width: '130px',
      render: (v, r) => <span style={{ fontSize: '12px' }}>{v || r.telefon || '—'}</span>,
      exportValue: r => r.cep_telefonu || r.telefon,
    },
    {
      key: 'email', label: 'E-posta', width: '160px',
      render: v => <span style={{ fontSize: '12px' }}>{v || '—'}</span>,
      exportValue: r => r.email,
    },
    {
      key: 'kayit_tarihi', label: 'Kayıt Tarihi', width: '110px',
      render: v => <span style={{ fontSize: '12px' }}>{fmt(v)}</span>,
      exportValue: r => fmt(r.kayit_tarihi),
    },
    {
      key: '_islem', label: 'İşlem', width: '90px', sortable: false, filterable: false,
      render: (_, r) => (
        <button className="btn btn-outline btn-xs" onClick={e => { e.stopPropagation(); navigate(`/sicil/${r.id}/duzenle`); }}>
          Düzenle
        </button>
      ),
    },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
        <h2 style={{ color: '#1a237e' }}>👤 Sicil Kayıtları</h2>
        <Link to="/sicil/yeni" className="btn btn-primary">➕ Yeni Sicil</Link>
      </div>
      <div className="card">
        <DataTable
          columns={columns}
          data={kayitlar}
          filename="sicil-kayitlari"
          pdfTitle="Sicil Kayıtları — Ünye Belediyesi"
          loading={yukleniyor}
          toolbar={
            <div className="sicil-toolbar-controls">
              <input
                className="search-input sicil-search-input"
                placeholder="🔍 Ad, soyad, ünvan, TC, vergi no..."
                value={q}
                onChange={e => setQ(e.target.value)}
              />
              <select value={sicilTipi} onChange={e => setSicilTipi(e.target.value)}>
                <option value="">Tüm Tipler</option>
                <option value="GERCEK">Gerçek Kişi</option>
                <option value="TUZEL">Tüzel Kişi</option>
                <option value="KAMU">Kamu Kurumu</option>
              </select>
              <button onClick={yukle} className="btn btn-secondary btn-sm">🔄 Yenile</button>
            </div>
          }
          rowKey="id"
          onRowClick={row => navigate(`/sicil/${row.id}/duzenle`)}
        />
      </div>
    </div>
  );
}
